import { format } from 'date-fns/esm'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Button from '../../Button'
import Icon from '../../Icon'
import Text from '../../Text'
import { Message } from '../type'
import { Audio, Progress } from './styles'

interface Props {
  type: 'sent' | 'received'
  message: Message
}

const AudioMessage: React.FC<Props> = ({ type, message }) => {
  const ref = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [progress, setProgress] = useState(0)
  const [interval, _setInterval] = useState<number | null>(null)

  useEffect(() => {
    if (ref && ref.current) {
      const audio = ref.current as unknown as HTMLAudioElement

      audio.onplaying = () => {
        setPlaying(true)
        _setInterval(
          setInterval(() => {
            setProgress(audio.currentTime)
          }),
        )
      }
      audio.onpause = () => {
        if (interval) {
          clearInterval(interval)
          _setInterval(null)
        }
        setPlaying(false)
      }

      audio.onended = () => {
        setPlaying(false)
        setProgress(0)
      }
    }
  }, [ref, interval])

  const toggle = useCallback(() => {
    const audio = ref.current as unknown as HTMLAudioElement
    if (playing) {
      audio.pause()
    } else {
      audio.play()
    }
  }, [ref, playing])

  return (
    <Audio
      type={type}
    >
      <audio
        ref={ref}
        hidden
      >
        <source
          src={message.upload?.url}
          type="audio/mpeg"
        />
      </audio>

      {ref && ref.current && (
        <>
          <Button
            label={(
              <Icon
                name={playing ? 'pause-circle' : 'play-circle'}
              />
            )}
            backgroundColor="transparent"
            smallPadding
            onClick={toggle}
          />

          <Progress
            total={
              (ref.current as unknown as HTMLAudioElement).duration
              || (message.duration != null && message.duration > 0 && message.duration! / 1000) || 0
            }
            current={progress}
          />

          <Text
            tag="span"
            size="hint"
            style={{
              wordBreak: 'normal',
            }}
          >
            {format(new Date(
              (
                (message.duration != null && message.duration > 0 && message.duration! / 1000) ||
                (ref.current as unknown as HTMLAudioElement).duration || 0
              ) * 1000 - progress * 1000,
            ), 'mm:ss')}
          </Text>
        </>
      )}

    </Audio>
  )
}

export default AudioMessage
